import { render, staticRenderFns } from "./zhichi.vue?vue&type=template&id=18a8b558&scoped=true&"
import script from "./zhichi.vue?vue&type=script&lang=js&"
export * from "./zhichi.vue?vue&type=script&lang=js&"
import style0 from "./zhichi.vue?vue&type=style&index=0&id=18a8b558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8b558",
  null
  
)

export default component.exports